import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { PairShareState } from ".";

const initialState: PairShareState = {
  question: undefined,
};

const store = proxy<PairShareState>({ ...initialState });

export const toolkitPairshareActions = {
  setQuestion(state: PairShareState) {
    Object.assign(store, initialState, state);
  },
};

export function useToolkitPairshareStore() {
  return useSnapshot(store);
}

export function getToolkitPairshareState() {
  return snapshot(store);
}

export function resetToolkitPairshareStore() {
  Object.assign(store, initialState);
}
